import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import PopUp from '../../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import IconError from '../../images/icon-error.svg';
import IconInsight from '../../images/icon-insight.svg';
import IconLike from '../../images/icon-like.svg';


const PremiumPackagePopup = (props) => {
    let icon = null;
    let title = '';
    let text = '';
    let buttonText1 = '';
    let buttonText2 = '';
    let showCallBack = false;

    switch (props.popupInfo.type) {
        case "installedSuccess":
            icon = IconLike;
            if (props.popupInfo.packagesCount == 1) {
                title = 'איזה כיף!\n  החבילה הותקנה בהצלחה';
                text = 'החבילה תהיה זמינה לצפייה\n תוך מספר דקות'
            }
            else {
                title = 'איזה כיף!\n החבילות הותקנו בהצלחה';
                text = 'החבילות יהיו זמינות לצפייה\n תוך מספר דקות'
            }
            buttonText1 = 'סיום';
            break;
        case "installedFailed":
            icon = IconError;
            if (props.popupInfo.packagesCount == 1) {
                title = 'מצטערים, משהו השתבש\n והחבילה לא הותקנה';
            }
            else {
                title = 'מצטערים, משהו השתבש\n החבילות לא הותקנו';
            }
            showCallBack = true;
            break;
        case "removedSuccess":
            icon = IconLike;
            title = 'החבילה הוסרה \n בהצלחה';
            text = props.popupInfo.text;
            buttonText1 = 'סיום';
            break;
        case "removedFailed":
            icon = IconError;
            title = 'מצטערים, משהו השתבש ולא\n הצלחנו לבטל את החבילה';
            showCallBack = true;
            break;
        case "alertBeforeRemoveBundlePackage":
            icon = IconInsight;
            title = 'חשוב לנו שתדעו';
            text = props.popupInfo.text;
            buttonText1 = 'אני רוצה לבטל';
            break;
        case "alertBeforeRemovePackage":
            icon = IconInsight;
            title = 'בטוח שאתם רוצים להסיר את \n ' + props.popupInfo?.packageTitle + '?';
            buttonText1 = 'אני רוצה לבטל';
            buttonText2 = 'לא, לחצתי בטעות'
            break;
        case "alert": //ex: Not support mobile alert - from cmsData
            icon = IconInsight;
            title = 'חשוב לנו שתדעו';
            text = props.popupInfo.text;
            buttonText1 = 'הבנתי, תודה';
            break;
        case "provisioningFailed":
            icon = IconError;
            title = 'מצטערים, משהו השתבש\nולא ניתן להשלים את הפעולה';
            text = <>אפשר ליצור איתנו קשר <br />חייגו {window.Config.technicalSupportPhone} לנציג שירות</>;
            buttonText1 = 'סיום';
            break;
        case "hboChangeSuccess":
            icon = IconLike;
            title = <>איזה כיף!<br />החבילה עודכנה בהצלחה</>;
            text = <>רק נשאר ליצור חשבון ב-HBO Max ולהתחיל לצפות</>;
            buttonText1 = 'ל-HBO Max';
            buttonText2 = 'ארשם מאוחר יותר';
            break;
        case "hboChangePlanSuccess":
            icon = IconLike;
            title = 'איזה כיף!\nהחבילה הוחלפה בהצלחה';
            buttonText1 = 'סיום';
            break;
        case "hboChangePlanFailed":
            icon = IconError;
            title = 'מצטערים, משהו השתבש\nולא הצלחנו לשנות את המסלול';
            text = `חייגו ${window.Config.technicalSupportPhone} לנציג שירות`;
            buttonText1 = 'סיום';
            break;
        case "disneyChangeSuccess":
            icon = IconLike;
            title = <>איזה כיף!<br />החבילה עודכנה בהצלחה</>;
            text = <>רק נשאר ליצור חשבון בדיסני+ ולהתחיל לצפות</>;
            buttonText1 = 'לדיסני+';
            buttonText2 = 'ארשם מאוחר יותר';
            break;
        case "disneyChangePlanSuccess":
            icon = IconLike;
            title = 'איזה כיף!\nהחבילה הוחלפה בהצלחה';
            buttonText1 = 'סיום';
            break;
        case "disneyChangePlanFailed":
            icon = IconError;
            title = 'מצטערים, משהו השתבש\nולא הצלחנו לשנות את המסלול';
            text = `חייגו ${window.Config.technicalSupportPhone} לנציג שירות`;
            buttonText1 = 'סיום';
            break;
        default:
            break;
    }

    return (
        <PopUp showPopUp={props.popupInfo.isDisplay} onClose={() => props.closePopUp(true)} className='premium-packages-catalog-popup'>
            <div className='premium-packages-catalog-popup-content'>
                <Image className='icon' src={icon} alt='' />
                <h2 className='popup-title'>{title}</h2>
                {text && <p className='popup-text'>{text}</p>}
                {props.popupInfo.type == 'alertBeforeRemovePackage' ?
                    <div className='btn-wrapper remove-package-btn'>
                        <BtnWhiteBlackBorderBigSize text={buttonText2} onclick={() => { props.closePopUp(true, buttonText2) }} />
                        {buttonText1 != '' && <BtnSubmit text={buttonText1} onclick={() => { props.closePopUp(false, buttonText1) }} />}
                    </div> :
                props.popupInfo.type == 'hboChangeSuccess' || props.popupInfo.type == 'disneyChangeSuccess' ?
                    <div className='btn-wrapper'>
                        <BtnSubmit text={buttonText1} onclick={() => { props.closePopUp(false, buttonText1) }} />
                        <button className='text-btn' onClick={() => { props.closePopUp(false, buttonText2) }}>{buttonText2}</button>
                    </div> :
                    buttonText1 != '' ? <div className='btn-wrapper'><BtnSubmit text={buttonText1} onclick={() => { props.closePopUp(false, buttonText1) }} /></div> : null
                }
                {showCallBack &&
                    <a className='service-phone' onClick={props.onClickCallToService} href={`tel:${window.Config.technicalSupportPhone}`}>חייגו {window.Config.technicalSupportPhone} לנציג שירות</a>
                }
            </div>
        </PopUp>
    );
};



export default PremiumPackagePopup;
